import {
  ContentType,
  getBaseContentTypeFromMimeType,
  getMostSuitableVideoMimeType,
} from '../../constants/mediaFormatProfiles';

export interface VideoRecordingFormat {
  mimeType: string;
  contentType: ContentType;
}

export function resolveVideoRecordingFormat(
  probeStream?: MediaStream,
): VideoRecordingFormat {
  const mimeType = getMostSuitableVideoMimeType(probeStream);

  return {
    mimeType,
    contentType: getBaseContentTypeFromMimeType(mimeType) ?? 'video/webm',
  };
}
